import React, { useEffect, useState, useRef } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import axios from 'axios';
import DataTable from "react-data-table-component";
import { env } from './const';
import { headers } from '../utils/common';
import { getRole } from '../utils/common';
import { Role } from '../utils/role';
import DeactivateFarm from './DeactivateFarm';
import { Modal, Button } from 'react-bootstrap';
import * as axiosInstance from '../utils/axiosinstace';
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n';
const MyProfile = () => {
  const { t, i18n } = useTranslation(['user', 'common', 'auth']);
    const [langMsg, setLangMsg] = useState(null); // { ok:boolean, key:string }

    // Changing the language here does two things: switches the UI immediately
    // (persisting to localStorage via the detector) and stores the choice against
    // the user server-side so it follows them to other devices. If the server
    // write fails — most likely the Phase 4 migration has not been applied — the
    // local switch still stands and we say so rather than silently succeeding.
    const onChangeLanguage = async (code) => {
        await i18n.changeLanguage(code);
        try {
            const res = await axiosInstance.updateUserLanguage(code);
            const ok = !!(res && (res.status === true || res.status === undefined));
            // store the key, not resolved text: the note must render in the
            // language just selected, not the one that was active on click
            setLangMsg({ ok, key: ok ? 'user:profile.languageSaved' : 'user:profile.languageSaveFailed' });
            if (ok) {
                const stored = JSON.parse(localStorage.getItem('user') || '{}');
                stored.language = code;
                localStorage.setItem('user', JSON.stringify(stored));
            }
        } catch (e) {
            setLangMsg({ ok: false, key: 'user:profile.languageSaveFailed' });
        }
    };
    const [role] = useState(getRole())
    const [data, setData] = useState({})
    const fetchData = async () => {
        try {
            const response = await axiosInstance.getUserProfile();
            setData(response.list);
        } catch (err) {
            alert(err)
            console.error(err);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="batchOperations">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('user:profile.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div class="card-body">
                    <div className="row">
                        <div className="col-md-6">
                        <h4 className="profileHeaders">{t('user:profile.userDetails')}</h4>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.organization')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.org != undefined && data.org!=''?data.org: '--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.name')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data?.farmerName}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.userName')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data?.userName}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.role')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data?.role}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.email')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.emailID != undefined && data.emailID !=''?data.emailID:'--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.phone')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.phoneNumber !==undefined && data.phoneNumber != ''? data.phoneNumber: '--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.address1')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.addressLine1 !=undefined && data.addressLine1 !=''?data.addressLine1:'--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.address2')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.addressLine2 !=undefined && data.addressLine2 !=''?data.addressLine2:'--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.city')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.city !=undefined && data.city !=''?data.city:'--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.state')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.state !=undefined && data.state !=''?data.state:'--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.country')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.country !=undefined && data.country !=''?data.country:'--'}
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.registeredDate')}</strong>
                                </div>
                                <div className="col-md-6">
                                    {data.profileCreatedDate!=undefined && data?.profileCreatedDate !=''?moment(data?.profileCreatedDate).format('DD-MMM-YYYY'): ''}
                                </div>
                            </div>
                            {/* <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.registeredBy')}</strong>
                                </div>
                                <div className="col-md-6">
                                {data?.createdBy}
                                </div>
                            </div> */}
                        </div>
                        <div className="col-md-6">
                            <h4 className="profileHeaders">{t('user:profile.preferences')}</h4>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight">
                                    <strong>{t('user:profile.language')}</strong>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-control"
                                        value={i18n.resolvedLanguage}
                                        onChange={(e) => onChangeLanguage(e.target.value)}
                                        aria-label={t('user:profile.language')}
                                    >
                                        {SUPPORTED_LANGUAGES.map((l) => (
                                            <option key={l.code} value={l.code}>{l.label}</option>
                                        ))}
                                    </select>
                                    {langMsg && (
                                        <small style={{ display: 'block', marginTop: 6, color: langMsg.ok ? '#1a7f37' : '#b3261e' }}>
                                            {t(langMsg.key)}
                                        </small>
                                    )}
                                </div>
                            </div>
                            <h4 className="profileHeaders">{t('user:profile.services')}</h4>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.barnSensors')}</strong>
                                </div>
                                <div className="col-md-6">
                                    <span className={data.barnsensors == 1?'activeHighlighter': 'inactiveHighlighter'}>
                                        {data.barnsensors == 1?'ACTIVE':'INACTIVE'}
                                    </span>
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.waterMeter')}</strong>
                                </div>
                                <div className="col-md-6">
                                    <span className={data.watermeter == 1?'activeHighlighter': 'inactiveHighlighter'}>
                                        {data.watermeter == 1?'ACTIVE':'INACTIVE'}
                                    </span>
                                </div>
                            </div>
                            <div className="row mbottom">
                                <div className="col-md-6 textRight" >
                                    <strong>{t('user:profile.controlSystem')}</strong>
                                </div>
                                <div className="col-md-6">
                                    <span className={data.controls == 1?'activeHighlighter': 'inactiveHighlighter'}>
                                        {data.controls == 1?'ACTIVE':'INACTIVE'}
                                    </span>
                                </div>
                            </div>
                            <div className='row' style={{marginTop: 20}}>
                                <div className='col-md-12'>
                                    <div style={{fontSize: 16, marginBottom: 15, fontWeight: 'bold', textAlign: 'center'}}>{t('auth:login.mobileApp')}</div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='qrHolder'>
                                        <img src='/dist/img/iPoutryAppStore.png' width={120}></img>
                                    </div>
                                    <a href='https://apps.apple.com/in/app/ipoultry/id6463606473' target='_blank'>
                                        <img src='/dist/img/appStore.png' width= {200}></img>
                                    </a>
                                </div>
                                <div className='col-md-6'>
                                    <div className='qrHolder'>
                                        <img src='/dist/img/iPoultry_playstore.png' width={120}></img>
                                    </div>
                                    <a href='https://play.google.com/store/apps/details?id=com.ipoultry&hl=en&gl=US' target='_blank'>
                                        <img src='/dist/img/playStore.png' width= {200}></img>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default MyProfile;